<template>
  <div>
    <div class="row">
      <div class="col-md-6 text-right">
        <span class="item-title">
          {{ $t('message.lblTuz6Row') }}{{ index + 1 }}</span>
        <button
          type="button"
          class="remove-item btn btn-danger btn-xs"
          @click="tuzemskePar6[index].deleted = true">
          <i class="fas fa-minus" />
        </button>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6">

        <b-form-group
          :name="`tuzemskePar6.$each.${index}.row`"
          :input-cols="8"
          :label="$t('message.lblDruhPrijmov')">
          <template slot-scope="{ attrs, listeners }">
            <b-form-select
              v-bind="attrs"
              v-model="tuzemskePar6[index].row"
              :options="druh"
              v-on="listeners"
            />
          </template>
        </b-form-group>

      </div>

      <div class="col-md-6">

        <b-form-group
          :name="`tuzemskePar6.$each.${index}.prijmy`"
          :label="$t('message.lblPrijmy')">
          <template slot-scope="{ attrs, listeners }">
            <b-form-input
              v-bind="attrs"
              v-model.trim="tuzemskePar6[index].prijmy"
              @input="tuzemskePar6[index].prijmy = tuzemskePar6[index].prijmy.replace(',', '.')"
              v-on="listeners"
            />
          </template>
        </b-form-group>

        <b-form-group
          v-if="(sposob!=='percent')"
          :name="`tuzemskePar6.$each.${index}.vydavky`"
          :label="$t('message.lblVydavky')">
          <template slot-scope="{ attrs, listeners }">
            <b-form-input
              v-bind="attrs"
              v-model.trim="tuzemskePar6[index].vydavky"
              @input="tuzemskePar6[index].vydavky = tuzemskePar6[index].vydavky.replace(',', '.')"
              v-on="listeners"
            />
          </template>
        </b-form-group>

      </div>
    </div>
  </div>
</template>

<script>
import bFormGroup from '@/components/form-group-col6'

export default {
  components: {
    bFormGroup
  },
  props: {
    index: {
      type: Number,
      required: true
    },
    tuzemskePar6: {
      type: Array,
      required: true
    },
    sposob: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      r18_sposob_uctovania: null,
      druh: [
        { value: '1', text: this.$t('message.druhMenu1') },
        { value: '2', text: this.$t('message.druhMenu2') },
        { value: '3', text: this.$t('message.druhMenu3') },
        { value: '4', text: this.$t('message.druhMenu4') },
        { value: '5', text: this.$t('message.druhMenu5') },
        { value: '6', text: this.$t('message.druhMenu6') },
        { value: '7', text: this.$t('message.druhMenu7') },
        { value: '8', text: this.$t('message.druhMenu8') },
        { value: '9', text: this.$t('message.druhMenu9') }
      ]
    }
  }
}
</script>

<style scoped>
.p12 .form-check {
    width: 12%;
}
.item-title {
    margin-top: 3.5%;
    text-align: right;
    font-weight: bold;
}
.pull-right {
    float: right;
}
.remove-item {
    display: inline !important;
    margin-left: 1em !important;
}
</style>
